import { render, staticRenderFns } from "./DHRDetail.vue?vue&type=template&id=dd8bdb88&scoped=true&"
import script from "./DHRDetail.vue?vue&type=script&lang=js&"
export * from "./DHRDetail.vue?vue&type=script&lang=js&"
import style0 from "./DHRDetail.vue?vue&type=style&index=0&id=dd8bdb88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8bdb88",
  null
  
)

export default component.exports